import { Component } from '@angular/core';
import { RouteDetailModalPresenter } from '../route-report-modal/route-detail-modal.presenter';

@Component({ selector: 'route-summary-by-day-modal', templateUrl: './route-summary-by-day-modal.component.html' })
export class RouteSummaryByDayModalComponent extends RouteDetailModalPresenter {
  readonly kind = 'daily-summary' as const;
}
